module.exports = __webpack_public_path__ + "img/2770cd6.jpg";